<template>
  <div class="wrapper">
    <div class="main-header" style="height: 100px">
      <div class="logo-header" data-background-color="blue">
        <a class="logo" href= "/">
          <img src="/f1/assets/img/F1-uwss.png" alt="navbar brand" class="navbar-brand" width="180">
        </a>
        <button class="navbar-toggler sidenav-toggler ml-auto" data-toggle="collapse" data-target="collapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon">
          <i class="icon-menu icon_menu_01" @click="toggle_mini"></i>
          </span>
        </button>
        <button class="topbar-toggler more">
          <i class="icon-options-vertical icon_menu_01" @click="toggle_mini"></i>
        </button>
        <div class="nav-toggle">
          <button class="btn btn-toggle toggle-sidebar">
            <i class="icon-menu icon_menu_01" @click="toggle_active"></i>
          </button>
        </div>
      </div>
      <!-- Navbar Header -->
      <nav class="navbar navbar-header navbar-expand-lg" data-background-color="blue2">
        <div class="container-fluid">
          <div class="collapse" id="search-nav">
            <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
              <li class="nav-item" data-name="/dashboad" style="padding-left:1rem; padding-right:0.5rem;">
                <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/dashboard')">
                  <img src="/f1/assets/img/dashboard.png" height="25" class="pl-1" style="margin-bottom:7px;">
                  <div class="nav_link_tit pr-2">통합</div>
                </a>
              </li>
              <li class="nav-item" data-name="/webcastle/dashboard">
                <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/webcastle/dashboard')">
                  <i class="fas fa-paste top_icon" style="margin-bottom:7px; color:#266a77; font-size: 2em !important"></i>
                  <div class="nav_link_tit">WEBCastle</div>
                </a>
              </li>
              <li class="nav-item" data-name="/wsfinder/dashboard">
                <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/wsfinder/dashboard')">
                  <i class="fas fa-table top_icon" style="margin-bottom:7px; color:#266a77; font-size: 2em !important"></i>
                  <div class="nav_link_tit">WSFinder</div>
                </a>
              </li>
              <li class="nav-item" data-name="/wmds/dashboard">
                <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/wmds/dashboard')">
                  <i class="fas fa-list-alt top_icon" style="margin-bottom:7px; color:#266a77; font-size: 2em !important"></i>
                  <div class="nav_link_tit">WMDS</div>
                </a>
              </li>
              <li class="nav-item" data-name="/integrity/main">
                <a class="nav-link" href="javascript:void(0)" @click="refresh_active('/integrity/main')">
                  <i class="fas fa-th-list top_icon" style="margin-bottom:7px; color:#266a77; font-size: 2em !important"></i>
                  <div class="nav_link_tit">WFDetector</div>
                </a>
              </li>
              <li class="nav-item" data-name="">
                <a class="nav-link" href="javascript:void(0)">
                  <div class="nav_link_tit" style="font-size: 1.2em !important; min-width: 45px;" @click="manual()">메뉴얼</div>
                </a>
              </li>
            </ul>
          </div>
          <!-- <DefaultHeaderDropdownAccnt/> -->
          <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
            <li class="nav-item dropdown hidden-caret">
              <Language />
            </li>
            <li class="nav-item dropdown hidden-caret">
              <a class="nav-link dropdown" href="javascript:void(0)" id="messageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-user-alt mr-1 user_i"></i>
                <span class="user">{{this.profile.username}}</span>
              </a>
              <ul class="dropdown-menu notif-box animated fadeIn" aria-labelledby="notifDropdown" style="width:220px;">
                <li>
                  <div class="dropdown-title">{{this.profile.permissions}}</div>
                </li>
                <li>
                  <div class="notif-center">
                    <router-link  to="/management/profile">
                      <div class="notif-icon notif-primary">
                        <i class="fas fa-address-card"></i>
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          프로필
                        </span>
                      </div>
                    </router-link>
                    <div class="dropdown-divider"></div>
                    <router-link to="/management">
                      <div class="notif-icon notif-primary">
                        <i class="fas fa-user-alt"></i>
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          관리
                        </span>
                      </div>
                    </router-link>
                    <div class="dropdown-divider"></div>
                    <router-link to="/wmds">
                      <div class="notif-icon notif-primary">
                        <i class="fas fa-list-alt"></i>
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          WMDS
                        </span>
                      </div>
                    </router-link>
                    <router-link to="/wsfinder">
                      <div class="notif-icon notif-primary">
                        <i class="fas fa-table"></i>
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          WSFinder
                        </span>
                      </div>
                    </router-link>
                    <router-link to="/webcastle">
                      <div class="notif-icon notif-primary">
                        <i class="fas fa-paste"></i>
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          WEBCastle
                        </span>
                      </div>
                    </router-link>
                    <router-link to="/integrity">
                      <div class="notif-icon notif-primary">
                        <i class="fas fa-th-list"></i>
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          통합
                        </span>
                      </div>
                    </router-link>
                    <router-link to="/board">
                      <div class="notif-icon notif-primary">
                        <i class="fa fa-clipboard"></i>
                      </div>
                      <div class="notif-content">
                        <span class="block">
                          게시판
                        </span>
                      </div>
                    </router-link>
                  </div>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown hidden-caret">
              <a class="nav-link btn" @click="toggle" id="notifDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-history nav_link_I" :class="{ 'text-secondary' : pause }" title="toggle auto logout"></i>
                <span class="notification" v-if="stale" :variant="pause ? 'secondary' : 'success'">{{stale}}</span>
              </a>
            </li>
            <li class="nav-item dropdown hidden-caret">
              <button class="btn btn-search" @click="logout()">
                <i class="fas fa-sign-out-alt mr-1"></i>
                <span>로그아웃</span>
              </button>
            </li>
          </ul>
        </div>
      </nav>
      <!-- End Navbar -->
    </div>
    <!-- Sidebar -->
    <div class="sidebar sidebar-style-2">
      <div class="sidebar-wrapper scrollbar scrollbar-inner scroll-content"
        style="height: 1235px; margin-bottom: 0px; margin-right: 0px; max-height: none;">
        <div class="sidebar-content">
          <ul class="nav nav-primary">
            <li class="nav-item" id="Integrate01" data-name="/dashboard" >
              <a href="javascript:void(0)" @click="refresh_active('/dashboard')">
                <i class="fas fa-print"></i>
                <p>통합</p>
              </a>
            </li>
            <li class="nav-item" id="Management01" data-name="/management">
              <a data-toggle="collapse" href="#Management">
                <i class="fas fa-user-alt"></i>
                <p>관리</p>
                <span class="caret"></span>
              </a>
              <div class="collapse" id="Management">
                <ul class="nav nav-collapse">
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/management/admin')">
                      <span class="sub-item">관리자</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/management/partner')">
                      <span class="sub-item">파트너</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/management/group')">
                      <span class="sub-item">그룹</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/management/user')">
                      <span class="sub-item">사용자</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/management/signup')">
                      <span class="sub-item">가입</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/management/signout')">
                      <span class="sub-item">탈퇴</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item" id="Billing01" data-name="/billing">
              <a data-toggle="collapse" href="#Billing">
                <i class="fas fa-file-invoice-dollar"></i>
                <p>청구</p>
                <span class="caret"></span>
              </a>
              <div class="collapse" id="Billing">
                <ul class="nav nav-collapse">
                  <li class="">
                    <a href="javascript:void(0)" @click="refresh_active('/billing/invoice_partner')">
                      <span class="sub-item">파트너 청구서</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/billing/invoice_group')">
                      <span class="sub-item">그룹 청구서</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/billing/payment')">
                      <span class="sub-item">비용</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item" id="Board01" data-name="/board">
              <a data-toggle="collapse" href="#Board">
                <i class="fa fa-clipboard"></i>
                <p>게시판</p>
                <span class="caret"></span>
              </a>
              <div class="collapse" id="Board">
                <ul class="nav nav-collapse">
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/board/main')">
                      <span class="sub-item">메인</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/board/qna')">
                      <span class="sub-item">Q &amp; A</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/board/faq')">
                      <span class="sub-item">FAQ</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/board/notice')">
                      <span class="sub-item">공지</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-section">
              <span class="sidebar-mini-icon">
                <i class="fa fa-ellipsis-h"></i>
              </span>
              <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                <span class="pr-1">
                  <!-- <img src="/f1/assets/img/solution.png" class="" width="24"> -->
                </span>
                보안 설정
              </h4>
            </li>
            <li class="nav-item" id="WEBCastle01" data-name="/webcastle">
              <a data-toggle="collapse" href="#WEBCastle">
                <i class="fas fa-paste"></i>
                <p>WEBCastle</p>
                <span class="caret"></span>
              </a>
              <div class="collapse" id="WEBCastle">
                <ul class="nav nav-collapse">
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/webcastle/dashboard')">
                      <span class="sub-item">상황판</span>
                    </a>
                  </li>
                  <!-- 버전에 따라 상, 하위 호환되는 template 이 달라져야함 -->
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/webcastle/modules')">
                      <span class="sub-item">서버 목록</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/webcastle/log')">
                      <span class="sub-item">로그</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/webcastle/policy')">
                      <span class="sub-item">정책</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item" id="WSFinder01" data-name="/wsfinder">
              <a data-toggle="collapse" href="#WSFinder">
                <i class="fas fa-table"></i>
                <p>WSFinder</p>
                <span class="caret"></span>
              </a>
              <div class="collapse" id="WSFinder">
                <ul class="nav nav-collapse">
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wsfinder/dashboard')">
                      <span class="sub-item">상황판</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wsfinder/agent')">
                      <span class="sub-item">에이전트</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wsfinder/detect')">
                      <span class="sub-item">탐지</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wsfinder/spattern')">
                      <span class="sub-item">시스템 패턴</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wsfinder/upattern')">
                      <span class="sub-item">사용자 패턴</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wsfinder/webshell')">
                      <span class="sub-item">WebShell 목록</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wsfinder/regist')">
                      <span class="sub-item">WebShell 업로드</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wsfinder/submitted')">
                      <span class="sub-item">제출된 WebShell</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item" id="WMDS01" data-name="/wmds">
              <a data-toggle="collapse" href="#WMDS">
                <i class="fas fa-list-alt"></i>
                <p>WMDS</p>
                <span class="caret"></span>
              </a>
              <div class="collapse" id="WMDS">
                <ul class="nav nav-collapse">
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wmds/dashboard')">
                      <span class="sub-item">상황판</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wmds/site')">
                      <span class="sub-item">사이트</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wmds/schedule')">
                      <span class="sub-item">일정</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wmds/policy')">
                      <span class="sub-item">정책</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wmds/result')">
                      <span class="sub-item">결과</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wmds/detect')">
                      <span class="sub-item">탐지</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wmds/spattern')">
                      <span class="sub-item">시스템 패턴</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/wmds/upattern')">
                      <span class="sub-item">사용자 패턴</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item" id="WFDetector01" data-name="/integrity">
              <a data-toggle="collapse" href="#WFDetector">
                <i class="fas fa-th-list"></i>
                <p>WFDetector</p>
                <span class="caret"></span>
              </a>
              <div class="collapse" id="WFDetector">
                <ul class="nav nav-collapse">
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/integrity/main')">
                      <span class="sub-item">메인</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/integrity/detect')">
                      <span class="sub-item">탐지</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-section">
              <span class="sidebar-mini-icon">
                <i class="fa fa-ellipsis-h"></i>
              </span>
              <h4 class="text-section text-uppercase" style="font-size: 12px; color: #fff">
                <span class="pr-1">
                  <!-- <img src="/f1/assets/img/system.png" class="" width="24"> -->
                </span>
                시스템
              </h4>
            </li>
            <li class="nav-item" id="Log01" data-name= "/log">
              <a data-toggle="collapse" href="#Log">
                <i class="fas fa-layer-group"></i>
                <p>로그</p>
                <span class="caret"></span>
              </a>
              <div class="collapse" id="Log">
                <ul class="nav nav-collapse">
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/log/login')">
                      <span class="sub-item">로그인</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/log/auth')">
                      <span class="sub-item">인증</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/log/action')">
                      <span class="sub-item">작업</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/log/system')">
                      <span class="sub-item">시스템</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/log/mail')">
                      <span class="sub-item">메일</span>
                    </a>
                  </li>
                  <div class="nav-item" data-name="/history">
                  </div>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/history/install')">
                      <span class="sub-item">설치</span>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" @click="refresh_active('/history/credit')">
                      <span class="sub-item">결제 이력</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item" id="Setting01" data-name="/system">
              <a href="javascript:void(0)" @click="refresh_active('/system/setting')">
                <i class="fas fa-cog"></i>
                <p>설정</p>
              </a>
            </li>
            <li class="nav-item" id="Mail01">
              <a href="javascript:void(0)" @click="refresh_active('/system/mail')">
                <i class="fas fa-envelope"></i>
                <p>메일</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!---------------------------------------------------------- sub-->
    <div class="main-panel">
      <div class="content">
        <div class="page-inner">
          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </div>
      </div>
      <footer fixed class="footer">
        <div class="container-fluid">
          <div>
            <div v-if="is_custom">
              -
            </div>
            <div v-else>
              <a href="http://www.f1security.co.kr">F1Security Inc.</a>
              <span>234, Beotkkot-ro, Geumcheon-gu, Seoul, Republic of Korea</span>
            </div>
          </div>
          <div class="mx-auto">
            Copyright 2019. F1Security Inc. All right reserved.
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>

<style>
html:not([dir="rtl"]) .sidebar {
  margin-left: 0px !important;
  height : 100%
}

.sidebar .nav {
  width : auto;
}

@media (max-width: 991.98px){
  .sidebar {
    width : 250px;
  }
}
</style>